import dJSON from 'dirty-json';

import Splide from '@splidejs/splide';

const moduleSelector = '.image-carousel';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query, index) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      const modalId = `imageGalleryModal-${index}`;

      if (!document.querySelector(`#${modalId}`)) {
        const modalHTML = /* html */ `
          <div id="${modalId}" class="modal modal-splide fade" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
              <div class="modal-content">            
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true" class="fa fa-times"></span>
                </button>
                <div class="gallery-main"></div>
                <div class="splide">
                  <div class="splide__track">
                    <div class="splide__list"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `;
        document.body.insertAdjacentHTML('beforeend', modalHTML);
      }

      // Add slides to main carousel
      data.forEach((item, slideIndex) => {
        query.querySelector('.splide.autoscroll .splide__list').insertAdjacentHTML('beforeend', /* html */ `
          <a data-toggle="modal" data-target="#${modalId}" data-slide-index="${slideIndex}" href="#" class="splide__slide">
            <div class="image-wrapper">
              <img src="${item.image}" alt="${item.alt}" />
            </div>
          </a>
        `);
      });

      // Add click handlers to the slides
      query.querySelectorAll('.splide.autoscroll .splide__slide').forEach((slide) => {
        slide.addEventListener('click', (e) => {
          e.preventDefault();
          const slideIndex = parseInt(slide.dataset.slideIndex, 10);
          const targetModalId = slide.dataset.target;
          const targetModal = document.querySelector(targetModalId);
          const modalSlider = targetModal.querySelector('.splide');
          if (modalSlider && !Number.isNaN(slideIndex)) {
            // Find the slider instance for this modal
            document.querySelectorAll('.modal-splide .splide').forEach((sliderEl) => {
              if (sliderEl.closest('.modal').id === targetModalId.replace('#', '')) {
                const instance = sliderEl.splide;
                if (instance) {
                  instance.go(slideIndex);
                }
              }
            });
          }
        });
      });

      // Add slides to this modal's carousel
      const modalList = document.querySelector(`#${modalId} .splide__list`);
      if (modalList) {
        data.forEach((item) => {
          modalList.insertAdjacentHTML('beforeend', /* html */ `
            <div class="splide__slide">
              <div class="image-wrapper">
                <img src="${item.image}" alt="${item.alt}" />
              </div>
            </div>
          `);
        });
      }
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

(() => {
  document.querySelectorAll('.image-carousel .splide').forEach((item) => {
    const isReverse = item.classList.contains('reverse');

    const slider = new Splide(item, {
      type: 'loop',
      perPage: 6,
      perMove: 1,
      gap: 10,
      arrows: false,
      pagination: false,
      autoplay: true,
      direction: isReverse ? 'rtl' : 'ltr',
      speed: 1000,
      interval: 5000,
      breakpoints: {
        1200: {
          perPage: 4,
        },
        768: {
          perPage: 3,
        },
        550: {
          perPage: 2,
        },
        481: {
          perPage: 1,
        },
      },
    });

    slider.mount();
  });

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();

(() => {
  document.querySelectorAll('.modal-splide .splide').forEach((item) => {
    const slider = new Splide(item, {
      type: 'loop',
      perPage: 5,
      perMove: 1,
      focus: 'center',
      gap: 10,
      pagination: false,
      arrows: true,
      arrowPath: 'M15.7502 27.1251C15.9259 26.9508 16.0654 26.7434 16.1606 26.5149C16.2558 26.2864 16.3048 26.0413 16.3048 25.7938C16.3048 25.5463 16.2558 25.3012 16.1606 25.0727C16.0654 24.8442 15.9259 24.6369 15.7502 24.4626L7.1252 15.8376H51.2627C51.76 15.8376 52.2369 15.64 52.5885 15.2884C52.9402 14.9368 53.1377 14.4598 53.1377 13.9626C53.1377 13.4653 52.9402 12.9884 52.5885 12.6367C52.2369 12.2851 51.76 12.0876 51.2627 12.0876H7.1627L15.7502 3.51882C16.0994 3.16751 16.2954 2.69229 16.2954 2.19694C16.2954 1.70159 16.0994 1.22637 15.7502 0.875065C15.3989 0.525845 14.9237 0.32983 14.4283 0.32983C13.933 0.32983 13.4578 0.525845 13.1064 0.875065L1.18145 12.8001C1.02094 12.9541 0.893234 13.1389 0.805992 13.3435C0.71875 13.5481 0.673775 13.7683 0.673775 13.9907C0.673775 14.2131 0.71875 14.4333 0.805992 14.6379C0.893234 14.8425 1.02094 15.0273 1.18145 15.1813L13.0877 27.1251C13.262 27.3008 13.4694 27.4403 13.6979 27.5355C13.9264 27.6307 14.1714 27.6797 14.4189 27.6797C14.6665 27.6797 14.9115 27.6307 15.14 27.5355C15.3685 27.4403 15.5759 27.3008 15.7502 27.1251Z',
      autoplay: false,
      breakpoints: {
        1200: {
          perPage: 4,
        },
        550: {
          perPage: 3,
        },
        481: {
          perPage: 2,
        },
      },
    });

    const galleryMain = item.parentNode.querySelector('.gallery-main');

    const updateGalleryMain = () => {
      const activeSlide = slider.Components.Elements.slides[slider.index];
      const activeImage = activeSlide.querySelector('img');
      if (activeImage && galleryMain) {
        galleryMain.innerHTML = `<img src="${activeImage.src}" alt="${activeImage.alt}" />`;
      }
    };

    slider.on('move', updateGalleryMain);
    slider.on('mounted', updateGalleryMain);

    // Add click handler for modal slides
    slider.on('click', (slide) => {
      slider.go(slide.index);
    });

    // Store the slider instance on the element for later use
    item.splideInstance = slider;

    slider.mount();
  });

  // Add click handlers to the main carousel slides
  document.querySelectorAll('.image-carousel .splide.autoscroll .splide__slide').forEach((slide) => {
    slide.addEventListener('click', (e) => {
      e.preventDefault();
      const slideIndex = parseInt(slide.dataset.slideIndex, 10);
      const modalId = slide.dataset.target;
      const modal = document.querySelector(modalId);
      const modalSlider = modal.querySelector('.splide');
      if (modalSlider && modalSlider.splideInstance && !Number.isNaN(slideIndex)) {
        // Wait for modal to be visible before moving slider
        setTimeout(() => {
          modalSlider.splideInstance.go(slideIndex);
        }, 500);
      }
    });
  });

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();
